export default {
  carta: "BUCHSTABE",
  yourLastOrders: "IHRE LETZTEN BESTELLUNGEN",
  productOrderNotAvailable: "Das bestellte Produkt ist leider nicht verfügbar.",
  noOrders: "Sie haben noch keine Bestellungen",
  updated: "Aktualisiert!",
  updatingzClosuresSummaryCollection:
    "zClosures-Zusammenfassungssammlung wird aktualisiert ...",
  updateOrdersAndPaymentSummariesCollection:
    "Aktualisieren der Sammlung von Bestellungen und Zahlungszusammenfassungen ...",
  whatDishesAre: "Welche Gerichte sind",
  theMaximumNumberOfProductAllowed:
    "Die maximal zulässige Anzahl von Produkten beträgt 20",
  orderPlaced: "Bestellung aufgegeben",
  updatePaymentsCollection: "Zahlungseinzug aktualisieren ..."
};
